import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setChildFormAction } from "../../redux/rootReducer";
import { CHILD_FORM_INITIAL } from "../../redux/initialStateConstant";
import { updateChildSagaAction } from "../../redux/sagaActions";

const ChildForm = () => {
    const dispatch = useDispatch();
    const child_form = useSelector(state => state.child_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setChildFormAction(CHILD_FORM_INITIAL)) }/>
                        <div className="form__title">Редактирование ребёнка</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Имя</div>
                        <input type="text" className="input"
                            value={ child_form.name }
                            onInput={ event => dispatch(setChildFormAction({
                                ...child_form,
                                name: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Дата рождения</div>
                        <input type="text" className="input"
                            value={ child_form.birthday }
                            onInput={ event => dispatch(setChildFormAction({
                                ...child_form,
                                birthday: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(updateChildSagaAction({
                                    child_id: child_form.id,
                                    name: child_form.name,
                                    birthday: child_form.birthday
                                }))
                            } }
                        >
                            Сохранить
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChildForm;